import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import Movies from './Movies';
import EmailSubscribe from './EmailSubscribe';
import SEO from './SEO'
import MovieLoading from './utils/Loading';

import './StartButton.css';

const StartButton = () => {
  const [moviesByProvider, setMoviesByProvider] = useState({});
  const [shownByProvider, setShownByProvider] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  // Define providers - easily add/remove providers here
  // no API call to reduce load times and because we don't add all providers
  // to the landing page
  const providers = [
    { key: 'netflix', name: 'Netflix' },
    { key: 'amazon', name: 'Amazon' },
    { key: 'max', name: 'Max' }
  ];

  let url = process.env.REACT_APP_API_URL;
  if (url === undefined) {
    url = "http://localhost:5051";
  }

  const DISPLAY = 5;
  const BATCH_SIZE = 50;

  useEffect(() => {
    const fetchMovies = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${url}/api/movie/list/?limit=${BATCH_SIZE}`);
        if (!response.ok) {
          throw new Error(`Could not fetch movie lists`);
        }
        const moviesData = await response.json();

        providers.map(
          provider => {
              shownByProvider[provider.key] = DISPLAY;
              setShownByProvider(shownByProvider);
          }
       )

        setMoviesByProvider(moviesData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMovies();
  }, [url]);

  const handleLoadMore = useCallback((providerKey) => {
    setShownByProvider(prev => ({
      ...prev,
      [providerKey]: prev[providerKey] + DISPLAY
    }));
  }, []);

  if (loading) return <MovieLoading/>;
  if (error) return <div>Error: {error}</div>;

 
  return (
    <div>
      <div>
        <img 
          src="./landing_logo.webp"
          alt="Site Logo"
          style={{ maxWidth: '100%', height: '250px' }}
        />
        <h3 style={{ fontFamily: "Bahnschrift", fontWeight: "600" }}>Handpicked Movies & Series worth watching on your favorite Streaming Services</h3>
        <EmailSubscribe/>
        <button onClick={() => navigate(`/findyourmovie`)} style={{backgroundColor: "#FFA500", fontSize: "1.2rem"}}>Find Your Movie</button>
      </div>

      
      {providers.map(provider => (
        <div key={provider.key}>
          <div className="list-header">
            <img src="./american_flag_small.webp" alt="Country Flag (USA)" />
            <h2>TOP {provider.name} Recommendations</h2>
            <div className="last-update">Updated 30 minutes ago</div>
          </div>
          <Movies
            movies={moviesByProvider[provider.key].slice(0, shownByProvider[provider.key]) || []} loading={loading}
            onLoadMore={() => handleLoadMore(provider.key)}
            hasMore={moviesByProvider[provider.key].length > shownByProvider[provider.key]}
            isLoading={loading}
            total={moviesByProvider[provider.key].length}

          />
        </div>
      ))}
    </div>
  );
};

export default StartButton;
